"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
document.addEventListener('DOMContentLoaded', () => {
    const renderOption = document.querySelector('.product-buy-buttons');
    const actionStickyButton = document.querySelector('.add-to-bag-buttons');
    const stickyButtonContainer = document.querySelector('#container-add-cart-sticky-button');
    const stickyButton = document.querySelector('#add-cart-sticky-button');
    const displayStickyTitle = document.querySelector('#display-sticky-product-info');
    const productTitle = document.querySelector('#product-title-display');
    const productSubTitle = document.querySelector('#product-subtitle-display');
    if (renderOption && actionStickyButton && stickyButtonContainer && stickyButton && displayStickyTitle) {
        if (productTitle && productSubTitle) {
            displayStickyTitle.innerText = `${productTitle.innerText} ${productSubTitle.innerText}`;
        }
        stickyButton.addEventListener('click', () => {
            actionStickyButton.click();
        });
        let isButtonVisible = false;
        /* eslint-disable no-inner-declarations */
        function handleScroll() {
            const treshHoldOption = renderOption.getBoundingClientRect();
            const currentSticky = stickyButtonContainer.getBoundingClientRect();
            const isInView = treshHoldOption.top >= 0 && treshHoldOption.bottom <= window.innerHeight;
            const isAbove = currentSticky.top < treshHoldOption.top;
            if ((isInView && isButtonVisible) || isAbove) {
                stickyButtonContainer.style.display = "none";
                isButtonVisible = false;
            }
            else if (!isInView && !isButtonVisible) {
                stickyButtonContainer.style.display = "flex";
                isButtonVisible = true;
            }
        }
        window.addEventListener('scroll', handleScroll);
        handleScroll();
    }
});
